import { AdapterFactory } from '../AdapterFactory';

export const notificationService = AdapterFactory.getNotificationAdapter();
